import { ConfigProvider } from "antd";
import thTH from "antd/lib/locale/th_TH";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import UserContextProvider from "./context/userContext";
import { ProtectedRoute } from "./res/protectedRoute";

import "./App.css";
import BatchItem from "./pages/batchItem";
import CheckoutOrderFocus from "./pages/checkout/checkoutFocus";
import ReturnOrderFocus from "./pages/checkout/returnorderFocus";
import UploadtrackPage from "./pages/checkout/uploadtrackingPage";
import CodeGPage from "./pages/code-g";
import CuttingPage from "./pages/cutting";
import Addsku from "./pages/editsku/addskuPage";
import EditmultiOrder from "./pages/editsku/editmultiorderPage";
import Editoneorder from "./pages/editsku/editoneorder/editskuPage";
import Editskutable from "./pages/editsku/editoneorder/editskutablePage";
import NotFound from "./pages/err/404"; // Replace 'MainContent' with your main content component
import FocusPack from "./pages/focus/pack";
import FocusPick from "./pages/focus/pick";
import OrderHistory from "./pages/history/order";
import HydroChat from "./pages/hydroChat";
import Auth from "./pages/login";
import HolderPage from "./pages/managestatusorder/changeholdOrder";
import WaitingPage from "./pages/managestatusorder/changewaitOrder";
import DashBoardPage from "./pages/order/dashboardorder";
import DashBoardPageWarehouse from "./pages/order/dashboardorderBatch";
import OrderMange from "./pages/orderManangement/OrderMange";
import PrintBatch from "./pages/orderManangement/PrintBatch";
import SearchItem from "./pages/orderManangement/SearchItem";
import SearchOrder from "./pages/orderManangement/SearchOrder";
import SumOrder from "./pages/orderManangement/SummaryOrder";
import SummaryOrderExpress from "./pages/orderManangement/SummaryOrderExpress";
import SoManagement from "./pages/OrderSo";
import RecheckOrder from "./pages/reCheckOrder";
import ReportOrder from "./pages/ReportsOrder";
import ReserveStock from "./pages/reserveStock";
import BatchSchedulePage from "./pages/batchSchedule";
import SupervisorDashboard from "./pages/supervisor/dashboard";
import UserAll from "./pages/userManagement/userDcom";
import UserManage from "./pages/userManagement/userManage";
import ShippingPage from "./pages/shipping/shippingPage";
import { PATHNAME } from "./res/pathName";

function App() {
  return (
    <ConfigProvider locale={thTH}>
      <UserContextProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/batch-instant" element={<BatchItem />} />
            <Route
              path="/focus/pick"
              element={
                <ProtectedRoute>
                  <FocusPick />
                </ProtectedRoute>
              }
            />
            <Route
              path="/focus/pack"
              element={
                <ProtectedRoute>
                  <FocusPack />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout/returnorderfocus"
              element={
                <ProtectedRoute>
                  <ReturnOrderFocus />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout/order/focus"
              element={
                <ProtectedRoute>
                  <CheckoutOrderFocus />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/dashboard-order"
              element={
                <ProtectedRoute>
                  <DashBoardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/dashboard-order-batch"
              element={
                <ProtectedRoute>
                  <DashBoardPageWarehouse />
                </ProtectedRoute>
              }
            />
            <Route
              path="/managestatus/editwaiting"
              element={
                <ProtectedRoute>
                  <WaitingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/managestatus/editholder"
              element={
                <ProtectedRoute>
                  <HolderPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout/uploadtracking"
              element={
                <ProtectedRoute>
                  <UploadtrackPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shipping/manage"
              element={
                <ProtectedRoute>
                  <ShippingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editsku/add"
              element={
                <ProtectedRoute>
                  <Addsku />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editsku/editoneorder-table"
              element={
                <ProtectedRoute>
                  <Editskutable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editsku/editoneorder"
              element={
                <ProtectedRoute>
                  <Editoneorder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editsku/editoneorder-multi"
              element={
                <ProtectedRoute>
                  <EditmultiOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order/print/batch"
              element={
                <ProtectedRoute>
                  <PrintBatch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order/manage"
              element={
                <ProtectedRoute>
                  <OrderMange />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order/sum"
              element={
                <ProtectedRoute>
                  <SumOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order/express/sum"
              element={
                <ProtectedRoute>
                  <SummaryOrderExpress />
                </ProtectedRoute>
              }
            />
            <Route
              path="/search/order"
              element={
                <ProtectedRoute>
                  <SearchOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/search/item"
              element={
                <ProtectedRoute>
                  <SearchItem />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reserve/stock"
              element={
                <ProtectedRoute>
                  <ReserveStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/report/order"
              element={
                <ProtectedRoute>
                  <ReportOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hydro/order"
              element={
                <ProtectedRoute>
                  <HydroChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order/so"
              element={
                <ProtectedRoute>
                  <SoManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recheck/order"
              element={
                <ProtectedRoute>
                  <RecheckOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user/all"
              element={
                <ProtectedRoute>
                  <UserAll />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user/managed"
              element={
                <ProtectedRoute>
                  <UserManage />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <NotFound />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cutting"
              element={
                <ProtectedRoute>
                  <CuttingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/code-g"
              element={
                <ProtectedRoute>
                  <CodeGPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history/order"
              element={
                <ProtectedRoute>
                  <OrderHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path={PATHNAME.SUPERVISORDASHBOARD}
              element={
                <ProtectedRoute>
                  <SupervisorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path={PATHNAME.BATCH_SCHEDULE}
              element={
                <ProtectedRoute>
                  <BatchSchedulePage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </UserContextProvider>
    </ConfigProvider>
  );
}

export default App;
